import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider, ThemeProvider, ToastProvider, networkMonitor, initSentry, ErrorBoundary, registerServiceWorker, initBuildVersionMonitor } from '@footypicks/shared';
import App from './App';
import './index.css';

initSentry({
  appName: 'main',
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  release: import.meta.env.VITE_SENTRY_RELEASE,
});

if (typeof window !== 'undefined' && import.meta.env.DEV) {
  (window as any).__networkMonitor = networkMonitor;
  networkMonitor.enable();
  console.log('💡 Network monitor ENABLED and available globally as: window.__networkMonitor');
}

registerServiceWorker();
initBuildVersionMonitor();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <ToastProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ToastProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </StrictMode>
);
